<script setup>

const props = defineProps({
  video: {
    type: Object,
  },
	start: {
		type: Number,
		default: 0
	}
})

const startAt = ref(props.start)

</script>

<template>
	<div v-if="video.type === 'VideoYoutube'" class="responsive-iframe-wrapper">
		<div class="responsive-iframe-container">
			<iframe
				:src="`https://www.youtube.com/embed/${video.attrs.youtubeId}${startAt ? `?start=${startAt}` : ''}`"
				title="YouTube video player"
				frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			></iframe>
		</div>
	</div>
	<a v-else class="relative" href="#">
		<div class="aspect-video bg-cover bg-no-repeat bg-center" :style="{ backgroundImage: `url(/temp/video.jpg)` }" />
		<svg class="absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%]" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
			<circle cx="50" cy="50" r="50" fill="#E6E6E6"/>
			<path d="M68 50L40 32V68L68 50Z" fill="#1D1D1B" stroke="#1D1D1B" stroke-width="3" stroke-linecap="square" stroke-linejoin="bevel"/>
		</svg>
	</a>
</template>

<style lang="scss" scoped>
.responsive-iframe-wrapper {
  width: 100%;
  margin: auto;
}
.responsive-iframe-container {
  position: relative;
  padding-bottom: 56.25%; /* zachová poměr 16:9 */
  height: 0;
  overflow: hidden;
}

/* Styl pro iframe */
.responsive-iframe-container iframe {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>